import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { UtilsService } from 'src/app/_services/utils.service';
import { environment } from 'src/environments/environment';
import { AlertApiDialog } from '../alert-api-error/alert-api-dialog';
import { AlertDialog } from '../alert-dialog/alert-dialog';
import { DateTime } from 'luxon';

export interface PlaceOrderRemarkDialogData {
  id: any;
  remark: any;
}

@Component({
  selector: 'app-place-order-remark-dialog',
  templateUrl: './place-order-remark-dialog.html',
  styleUrls: ['./place-order-remark-dialog.scss'],
})
export class PlaceOrderRemarkDialog implements OnInit {
  ngModelOptions: any = {
    standalone: true,
  };
  confirmButtonColor: string = 'warn';
  dataSource: {
    id: number;
    [key: string]: any;
  } = {
    id: null,
  };

  remark: any = null;
  remarkData: any = null;
  saveButtonDisabledValue = false;
  constructor(
    public dialogRef: MatDialogRef<PlaceOrderRemarkDialog>,
    @Inject(MAT_DIALOG_DATA) public data: PlaceOrderRemarkDialogData,
    private httpClient: HttpClient,
    private router: Router,
    private utilsService: UtilsService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    // if (this.data.confirmButtonColor) {
    //   this.confirmButtonColor = this.data.confirmButtonColor;
    // }
    if (this.data.id) {
      this.dataSource.id = this.data.id;
    }
    if (this.data.remark) {
      this.dataSource.remark = this.data.remark;
    }

    try {
      this.remark = JSON.parse(this.data.remark);
    } catch (err) {}
  }
  updateRemark(): void {
    if (this.remarkData == null) {
      this.dialogRef.close();
      this.utilsService.showError('Please enter remark').then((res) => {});
      return;
    }
    if (this.remark) {
      this.remark.push({
        datetime: DateTime.now().toUTC().toISO(),
        by: window.localStorage.getItem('username'),
        statusCode: null,
        remark: this.remarkData,
      });
    } else {
      this.remark = [
        {
          datetime: DateTime.now().toUTC().toISO(),
          by: window.localStorage.getItem('username'),
          statusCode: null,
          remark: this.remarkData,
        },
      ];
    }

    this.dataSource.remark = JSON.stringify(this.remark);

    this.httpClient
      .post<any>(
        `${environment.baseApiUrl}/placeOrders/update`,
        this.dataSource
      )
      .pipe(
        concatMap((res) => {
          this.saveButtonDisabledValue = false;
          if (!res.success) {
            //  this.errorFlag = true;
            //return this.utilsService.showAlert(res.message, res.errors);
            this.dialogRef.close();
            return this.openAlertApiDialog(res.message, res.errors);
          }
          this.dialogRef.close();
          return this.utilsService.showToast(res.message);
        }),
        catchError((err) => {
          const defaultMessage =
            'Unable to update place order. Maybe connectivity issue?';
          const message =
            err instanceof HttpErrorResponse
              ? defaultMessage
              : typeof err === 'object'
              ? err.message
              : err ?? defaultMessage;

          //return this.utilsService.showAlert(message);
          this.dialogRef.close();
          return this.openAlertDialog(message);
        })
      )
      .subscribe();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  openAlertDialog(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertDialog, {
      disableClose: false,
      data: {
        message: message,
      },
    });

    return dialogRef.afterClosed();
  }

  openAlertApiDialog(message: string, errors: any[]): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertApiDialog, {
      disableClose: false,
      data: {
        message: message,
        errors: errors.map((v) => v.message).join('\n'),
      },
    });

    return dialogRef.afterClosed();
  }
}
